import { useCountUp } from '../../lib/useCountUp';

/**
 * LiveNumber — animates from 0 to `value` when it enters the viewport.
 * Tabular-nums monospaced for perfect alignment.
 */
export const LiveNumber = ({
  value,
  prefix = '',
  suffix = '',
  decimals = 0,
  className = '',
  duration = 800,
}) => {
  const [ref, display] = useCountUp(value, { duration, decimals });
  const formatted = display.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return (
    <span ref={ref} className={`ig-numeric ${className}`}>
      {prefix}{formatted}{suffix}
    </span>
  );
};
